module.exports = __webpack_public_path__ + "img/25.daeeadd2.jpg";